<template>
  <div class="head">
    {{title}}
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>

<style lang="scss" scoped>
  .head {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 26px;
    color: #4C5056;
  }
</style>